import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { api } from '../services/api';

const Login = ({ onLogin }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); setError('');
        try {
            const token = await api.login(password);
            onLogin(token);
        } catch (err) {
            setError('Incorrect Password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-xl shadow-xl w-full max-w-sm">
                <div className="flex justify-center mb-6">
                    <div className="bg-blue-100 p-4 rounded-full">
                        <Lock className="text-blue-600" size={32} />
                    </div>
                </div>
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Construction Manager</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <input 
                            type="password" 
                            className="w-full border-2 border-gray-200 rounded-lg p-3 outline-none focus:border-blue-500 transition-colors"
                            placeholder="Enter Access Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoFocus
                        />
                    </div>
                    {error && <div className="text-red-500 text-sm text-center font-bold">{error}</div>}
                    <button 
                        type="submit" 
                        disabled={loading}
                        className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors disabled:opacity-50"
                    >
                        {loading ? 'Verifying...' : 'Unlock App'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;